

<div class="Dialog-body">
  <div class="modal-header">
    
    <div class="sc-badge sc-safe" style="padding: 4px 3px !important;">{{QuestionName}}</div>
</div>
  <form>
    <div class="input-label" style="text-align: center">Action Observed</div>
    <mat-form-field style="width: 450px;">  
      <textarea class="sc-textarea" matInput [(ngModel)]="ActionObserved" [ngModelOptions]="{standalone: true}"></textarea>
    </mat-form-field>

    <div class="input-label" style="text-align: center">Responsibility</div>
    <mat-form-field style="width: 450px;">  
      <textarea class="sc-textarea" matInput [(ngModel)]="Responsibility" [ngModelOptions]="{standalone: true}"></textarea>
    </mat-form-field>


    <div class="input-label" style="text-align: center">Follow up actions/Timeframes</div>
    <mat-form-field style="width: 450px;">  
      <textarea class="sc-textarea" matInput [(ngModel)]="FollowUpActions" [ngModelOptions]="{standalone: true}"></textarea>
    </mat-form-field>
   
      <div class="buttonbelow">
        <button mat-button (click) = "SaveQuestionComments()" >Submit</button>
        <button mat-button  (click)="DialogClose()" >Cancel</button>    
      </div>
  </form>

</div>
